import {
  QAS_REQUIRED_FIELD_HIDDEN_GROUP_MAPS,
  QAS_REQUIRED_FIELD_ADDITIONAL_GROUP_MAPS,
  QAS_REQUIRED_FIELD_HIDDEN_FIELDS_MAPS,
} from 'pages/qas-require-field/constants';

export const hideQasRequiredFieldGroup = (fieldGroups, productType) => {
  const hiddenGroups = QAS_REQUIRED_FIELD_HIDDEN_GROUP_MAPS[productType] || [];

  const newFieldGroups = fieldGroups.filter(
    (val) => !hiddenGroups.includes(val?.groupName)
  );

  return hiddenGroups ? newFieldGroups : fieldGroups;
};

export const showQasRequiredFieldSpecificGroup = (fieldGroups, productType) => {
  const allAdditionalGroupList = Object.values(
    QAS_REQUIRED_FIELD_ADDITIONAL_GROUP_MAPS
  ).flat();

  const newFieldGroups = fieldGroups.filter((groupItem) => {
    const additionalGroup =
      QAS_REQUIRED_FIELD_ADDITIONAL_GROUP_MAPS[productType];

    const filterOutAdditionalGroups = additionalGroup
      ? allAdditionalGroupList.filter((additionalGroupItem) => {
          return !additionalGroup.includes(additionalGroupItem);
        })
      : allAdditionalGroupList;

    //* filter
    return !filterOutAdditionalGroups.includes(groupItem.groupName);
  });

  return newFieldGroups;
};

export const checkVisibleField = ({ fieldItem, productType }) => {
  return !QAS_REQUIRED_FIELD_HIDDEN_FIELDS_MAPS[productType]?.includes(
    fieldItem.fieldFullPath
  );
};
